import React, { Component } from "react";
import NavigationChange from "../../components/NavigationChange";
import { Form } from "react-bootstrap";
import Pagination from "@mui/material/Pagination";
import CreateEmployee from "./CreateEmployee";
import EmployeeGrid from "./EmployeeGrid";
import ManageUserService from "../../api/ManageUserService";
import AuthService from "../../session/AuthService";
import { Toaster, toast } from "react-hot-toast";
import { connect } from "react-redux";
import { getExpiredDate, getnotificationCount } from "../../redux/actions/MangeUserProfileAction";

class EmployeeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      userCount: 0,
      totalPageNo: null,
      openModal: false,
      changeStateforEdit: false,
      pageNo: 0,
      search: "",
      currentPage: 1,
      gender: "",
      anchorEl: null,
    };
  }

  componentDidMount = () => {

    console.log("AuthService.getUserTypeAdmin()::",typeof AuthService.getUserTypeAdmin(), AuthService.getUserTypeAdmin());
    this.getAllEmployee();
    AuthService.getUserType() === "1" && this.props.getnotificationCount();
  };

  getAllEmployee = () => {
    let obj = {
      pageNo: 0,
      search: "",
      group_id: parseInt(AuthService.getUserId()),
      gender: "",
      userType: this.props.isAdmin && "3",
      allData : !this.props.isAdmin && AuthService.getUserTypeAdmin() && "all",
    };

    ManageUserService.getAllEmployee(obj).then((response) => {
      console.log("response", response.data.status);
      this.props.getExpiredDate(response.data.status);
      if (response.data && response.data.data) {
        this.setState({
          userList: response.data.data.userList,
          userCount: response.data.data.totalCount,
          totalPageNo: response.data.data.totalPageNo,
        });
      }
    });
  };

  render() {
  
    // console.log("this.props?.isAdmin::", !this.props?.isAdmin || true);
    
    return (
      <>
        <div className="Heading" >
          <NavigationChange
            Topics={"Employee"}
            numberofRecord={this.state.userCount}
            specficwidth={"134"}
            back={!this.props?.isAdmin ?? true}
          />
        </div>
        <div className="container-of-createButton" id="titleWithDropdowns">
          <div className="search-contain">
            <Form.Label style={{ fontSize: "17px" }}>Search</Form.Label>

            <div className="search">
            <span className="fa fa-search" onClick={this.search}></span>
            <input
              type="text"
              placeholder={AuthService.getUserTypeAdmin() === "1" ? "Employee Name" : "Employee Name or Email"}
              name="search"
              value={this.state.search}
              onKeyPress={this.handleKeyPress}
              onChange={this.searchvalue}
              
            />
          </div>
            {/* <div class="form-group has-search">
              <span class="fa fa-search form-control-feedback" onClick={this.search}></span>
              <input
                type="text"
                class="form-control"
                placeholder="Type Here..."
                name="search"
                value={this.state.search}
                onKeyPress={this.handleKeyPress}
                onChange={this.searchvalue}
              />
            </div> */}
          </div>

          {/* <div className="col-2 custom-select">
            <Form.Label style={{ fontSize: "17px" }}>Gender </Form.Label>
            <select
              value={this.state.gender}
              onChange={(event) => this.handleGenderSelect(event.target.value)}
              style={{
                backgroundColor: "rgba(243, 244, 241, 1)",
                color: "black",
                borderColor: "rgba(243, 244, 241, 1)",
                width: "100%",
                height: "60%",
                borderRadius: "5px",
              }}
            >
              <option value="">All</option>
              <option value="male">Male</option>
              <option value="female">Female</option>
            </select>
          </div> */}


{String(AuthService.getUserTypeAdmin()) !== "3" && (
    <div className="create-button">
    <div className="button-end">
      <button
        className="btn btn-success"
        onClick={this.OpenCreateTask}
        style={{
          backgroundColor: "#8ABC49",
          borderColor: "#8ABC49",
        }}
      >
        Add Employee
      </button>
      {/* <button
        className="btn btn-success"
        onClick={this.OnCheckstatus}
        style={{
          backgroundColor: "#8ABC49",
          borderColor: "#8ABC49",
        }}
      >
       User Status
      </button> */}
    </div>
  </div>
)}
         
        </div>
        <EmployeeGrid
          userList={this.state.userList}
          ActiveEdit={(a) => this.activeEdit(a)}
          onLoad={this.getAllEmployee}
          isAdmin={this.props.isAdmin ?? false}
        />

        <div className="mt-3" style={{ width: "99%", margin: "0 auto" }}>
          <div className="d-flex justify-content-center">
            <Pagination
              count={this.state.totalPageNo}
              onChange={(event, value) => this.handlePageChange(value)}
              page={this.state.currentPage}
            />
          </div>
        </div>

        {this.state.openModal && (
          <CreateEmployee
            handleClose={this.closeHandleclose}
            show={this.state.openModal}
            onLoad={this.getAllEmployee}
            option={!this.state.changeStateforEdit ? "new" : "edit"}
            editValue={this.state.editValue}
            renderToast={(a) => this.renderToast(a)}
            errorToast={(a) => this.errorToast(a)}
          />
        )}
        <Toaster />
      </>
    );
  }

  handleFilterClick = (event) => {
    this.setState({
      anchorEl: event.target,
    });
  };

  handleFilterClose2 = () => {
    this.setState({
      anchorEl: null,
    });
  };

  handleGenderSelect = (selectedValue) => {
    this.setState(
      {
        gender: selectedValue,
      },
      () => {
        let obj = {
          pageNo: 0,
          search: this.state.search,
          group_id: parseInt(AuthService.getUserId()),
          gender: this.state.gender,
        };

        ManageUserService.getAllEmployee(obj).then((response) => {
          console.log("response", response);
          if (response.data && response.data.data) {
            this.setState({
              userList: response.data.data.userList,
              userCount: response.data.data.totalCount,
              totalPageNo: response.data.data.totalPageNo,
              anchorEl: null,
            });
          }
        });
      }
    );
  };

  searchvalue = (event) => {
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        if (event.target.value.length === 0) {
          this.search();
        }
      }
    );
  };

  handleKeyPress = (event) => {
    if (event.key === "Enter") {
      this.search();
    }
  };

  search = () => {
    let obj = {
      pageNo: 0,
      search: this.state.search,
      group_id: parseInt(AuthService.getUserId()),
      gender: this.state.gender,
      userType: this.props.isAdmin && "3",
      allData : !this.props.isAdmin && AuthService.getUserTypeAdmin() && "all"
    };

    ManageUserService.getAllEmployee(obj).then((response) => {
      console.log("response", response);
      if (response.data && response.data.data) {
        this.setState({
          userList: response.data.data.userList,
          userCount: response.data.data.totalCount,
          totalPageNo: response.data.data.totalPageNo,
        });
      }
    });
  };

  activeEdit = (a) => {
    this.setState({
      changeStateforEdit: true,
      editValue: a,
      openModal: true,
    });
  };

  OpenCreateTask = () => {
    this.setState({
      openModal: true,
      changeStateforEdit: false,
    });
  };

//   OnCheckstatus = () => {
//     let obj={id: 2};
//     ManageUserService.checkSubscriptionStatus(obj).then((response) => {
//       console.log("response", response);
//   });
// }

  closeHandleclose = () => {
    this.setState({
      openModal: false,
    });
  };

  handlePageChange = (i) => {
    let page = null;
    if (i === 1) {
      page = 0;
    } else {
      page = i - 1;
    }
    this.setState({ currentPage: i, pageNo: page }, () => {
      let obj = {
        pageNo: this.state.pageNo,
        search: this.state.search,
        group_id: parseInt(AuthService.getUserId()),
        gender: this.state.gender,
        userType: this.props.isAdmin && "3",
      allData : !this.props.isAdmin && AuthService.getUserTypeAdmin() && "all"
      };
      ManageUserService.getAllEmployee(obj).then((response) => {
        console.log("response", response);
        if (response.data && response.data.data) {
          this.setState({
            userList: response.data.data.userList,
            userCount: response.data.data.totalCount,
            totalPageNo: response.data.data.totalPageNo,
          });
        }
      });
    });
  };

  renderToast = (a) => {
    toast.success(`Employee ${a} Successfully`);
  };


  errorToast = (status) => {
    toast.error(`${status}`);
  }
}

const mapStateToProps = function (state) {
  return {

  };
};

const mapDispatchToProps = function (dispatch) {
  return {
   
    getExpiredDate: (data) => dispatch(getExpiredDate(data)),
    getnotificationCount :  (data) => dispatch(getnotificationCount(data)),

   

  };
};

export default connect(mapStateToProps, mapDispatchToProps)(EmployeeContainer);

